import { IState } from 'core';
import { createSelector } from '@reduxjs/toolkit';
import { ILastWinnersState } from './types';

const lastWinnersDataSelector = (state: IState) => state.rouletteReducer.lastWinnersReducer;

export const lastWinnersSelector = createSelector(
  lastWinnersDataSelector,
  (state: ILastWinnersState) => state.lastWinners,
);
